import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { Box, Input, Table, TableCaption, Thead, Tbody, Tr, Th, Td, TableContainer ,Button,useDisclosure} from "@chakra-ui/react";
import KotBillPrintModal from './kotBillPrintModal';

const KotBillData = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const {isOpen,onOpen,onClose}=useDisclosure()
  const handlePrintModalOpen=()=>{
    onOpen()
  }

  const customerId = localStorage.getItem('customerId');

  const fetchData = async () => {
    const response = await axios.get(`https://api.hotel.tdrsoftware.in/api/getKotbilldata/${customerId}`);
    setData(response.data);
    setFilteredData(response.data);
  };

  useEffect(() => {
    fetchData();
  }, [customerId]);

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
    filterData(event.target.value, startDate, endDate);
  };

  const handleStartDateChange = (event) => {
    setStartDate(event.target.value);
    filterData(searchTerm, event.target.value, endDate);
  };

  const handleEndDateChange = (event) => {
    setEndDate(event.target.value);
    filterData(searchTerm, startDate, event.target.value);
  };

  const filterData = (term, start, end) => {
    let filtered = data.filter(order => {
      const orderDate = new Date(order.createdAt).getTime();
      const startFilter = start ? new Date(start).getTime() : null;
      const endFilter = end ? new Date(end).getTime() : null;

      if (term && !order.roomNo.includes(term)) {
        return false;
      }

      if (startFilter && endFilter) {
        return orderDate >= startFilter && orderDate <= endFilter;
      }

      if (startFilter) {
        return orderDate >= startFilter;
      }

      if (endFilter) {
        return orderDate <= endFilter;
      }

      return true;
    });

    setFilteredData(filtered);
  };

  return (
    <Box>
      <Input
        w='30%'
        type="text"
        placeholder="Search by Room Number"
        value={searchTerm}
        onChange={handleSearchChange}
        mb={4} // Adds margin bottom for spacing
      />
      <Input
        w='20%'
        type="date"
        placeholder="Start Date"
        value={startDate}
        onChange={handleStartDateChange}
        mr={2}
      />
      <Input
        w='20%'
        type="date"
        placeholder="End Date"
        value={endDate}
        onChange={handleEndDateChange}
        mr={2}
      />
      <Button colorScheme="blue" onClick={handlePrintModalOpen}  p={2} >
             Print
            </Button>
      <KotBillPrintModal isOpen={isOpen} onClose={onClose}  onOpen={onOpen} customerId={customerId} foodBillData={filteredData} />
      <TableContainer width='full'>
        <Table size='sm' variant='striped' colorScheme='green'>
          <TableCaption>Food Data</TableCaption>
          <Thead>
            <Tr>
              <Th>Food Item</Th>

              <Th>RoomNo</Th>
              <Th>KotNo</Th>
              <Th>Total Bill</Th>
              <Th>Created At</Th>
              <Th>Modify</Th>
            </Tr>
          </Thead>
          <Tbody>
            {filteredData.map((order, index) => (
              <Tr key={index}>
                <Td><Table size='sm' variant='striped' colorScheme='yellow'>
                  <Tr>
                    <Th>Name</Th>
                    <Th>Quantity</Th>
                    <Th>Price</Th>
                  </Tr>
                  <Tbody>
                    {order?.foodItem.map((item, itemIndex) => (
                      <Tr key={itemIndex}>
                        <Td>{item.name}</Td>
                        <Td>{item.quantity}</Td>
                        <Td>{item.price}</Td>
                      </Tr>
                    ))}
                  </Tbody>
                </Table></Td>
                <Td>{order.roomNo}</Td>
                <Td>{order.kotNo}</Td>
                <Td>{order.totalBilling}</Td>
                <Td>{new Date(order.createdAt).toLocaleString('en-GB')}</Td>
                <Td><Button variant='solid' colorScheme='green' onClick={()=>{navigate('/foodBill',{
                  state:{
                    kotNo:order.kotNo,
                    roomNo:order.roomNo,
                    id:order._id,
                    registration:order.registration,
                  }
                })}}>Modify</Button></Td>

              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default KotBillData;
